import { makeStyles } from "@mui/styles";

const useInstructionsStyles = makeStyles(({ theme }) => ({
  instructionsRoot: {
    position: "relative",
    minHeight: "100vh",
    paddingLeft: "30px",
    "@media (max-width: 768px)": {
      paddingLeft: "0px",
    },
  },
  instructionsBody: {
    backgroundColor: "#ffffff",
    height: "90vh",
    overflowY: "auto",
    "@media (min-width: 800px) and (max-width: 898px)": {
      padding: "16px",
    },
  },
  instructionsList: {
    listStyleType: "decimal",
    marginLeft: 24,
    marginTop: 16,
    "& ul": {
      listStyleType: "disc",
      marginLeft: 24,
      marginTop: 8,
    },
  },
  nextButton: {
    float: "right",
    // marginTop: '50px',
  },
  popupModal: {
    backgroundColor: "#ffffff",
    // backgroundColor: "red",
    // padding: 24,
    borderRadius: 8,
    // maxWidth: 600,
    // width: "100%",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
  },
  popupNote: {
    fontWeight: 600,
    marginBottom: 16,
  },
  checkboxSection: {
    marginTop: 16,
    display: "flex",
  },
  popupActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 16,
    marginTop: 24,
  },
  langSelect: {
    minWidth: 120,
  },
  instructionContent: {
    margin: "20px",
    paddingRight: "20px",
    height: "90%",
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "10px",
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 5px grey",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#4565B7",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#39476B",
    },
  },
  instructionContent: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
   instructionsContainer: {
    flex: 1,
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "10px",
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 5px grey",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#4565B7",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#39476B",
    },
    paddingLeft: "20px",
    paddingRight: "20px",
    fontSize: "1rem", // Default font size
    
    // General typography styles
    "& h1, & h2, & h3, & h4, & h5, & h6": {
      margin: "16px 0 8px 0",
      lineHeight: 1.3,
    },
    "& p": {
      margin: "8px 0",
      lineHeight: 1.6,
    },
    "& ul, & ol": {
      margin: "8px 0",
      paddingLeft: "24px",
    },
    "& li": {
      margin: "4px 0",
    },
    "& img": {
      width: "100% !important",
      height: "auto !important",
      maxWidth: "100%", // Ensures responsiveness
    },
    // Media query for 800px-898px
    "@media (min-width: 800px) and (max-width: 898px)": {
      fontSize: "0.5rem", // 50% of original size
      
      // Adjust typography for smaller font size
      "& h1, & h2, & h3, & h4, & h5, & h6": {
        margin: "12px 0 6px 0",
      },
      "& p": {
        margin: "6px 0",
      },
      "& ul, & ol": {
        paddingLeft: "18px",
      },
      "& img": {
        width: "100%",
      },
    },
  },
}));

export default useInstructionsStyles;
